import React, { useState, useEffect, useCallback } from 'react';
import Post from './Post';

const ReplySection = ({ 
  postUri, 
  postCid, 
  bluesky, 
  isLoggedIn, 
  onLoginRequired,
  bookmarkService,
  onLike
}) => {
  const [replies, setReplies] = useState([]);
  const [newReply, setNewReply] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchReplies = useCallback(async () => {
    if (!bluesky.agent.session) {
      await bluesky.createPublicSession();
    }
    
    setIsLoading(true);
    try {
      const response = await bluesky.getReplies(postUri);
      if (response.success) {
        setReplies(response.data);
      } else {
        setError('Failed to load replies');
      }
    } catch (err) {
      setError('Error loading replies');
    } finally {
      setIsLoading(false);
    }
  }, [bluesky, postUri]);

  useEffect(() => {
    fetchReplies();
  }, [fetchReplies]);

  const handleSubmitReply = async (e) => {
    e.preventDefault();
    
    if (!isLoggedIn) {
      onLoginRequired();
      return;
    }

    if (!newReply.trim()) return;

    setIsLoading(true);
    try {
      const response = await bluesky.createReply(postUri, postCid, newReply);
      if (response.success) {
        setNewReply('');
        fetchReplies();
      } else {
        setError('Failed to post reply');
      }
    } catch (err) {
      setError('Error posting reply');
    } finally {
      setIsLoading(false);
    }
  };

  return (
	<div className="replies-section">
	  {isLoggedIn && (
		<form onSubmit={handleSubmitReply} className="reply-form">
		  <textarea
			value={newReply}
			onChange={(e) => setNewReply(e.target.value)}
			placeholder="Write a reply..."
			className="reply-input"
			disabled={isLoading}
		  />
		  <button 
			type="submit" 
			className="button button-primary"
			disabled={isLoading || !newReply.trim()}
		  >
			{isLoading ? 'Sending...' : 'Reply'}
		  </button>
		</form>
	  )}

	  {error && <div className="error-message">{error}</div>}

	  <div className="replies-list">
		{isLoading && !replies.length ? (
		  <div className="loading-replies">Loading replies...</div>
		) : replies.length > 0 ? (
		  replies.map((reply) => (
			<Post
			  key={reply.cid}
			  post={reply}
			  bluesky={bluesky}
			  isLoggedIn={isLoggedIn}
			  onLoginRequired={onLoginRequired}
			  onLike={onLike}
			  bookmarkService={bookmarkService}
			  isLoading={isLoading}
			/>
		  ))
		) : (
		  <div className="no-replies">No replies yet</div>
		)}
	  </div>
	</div>
  );
};

export default ReplySection;